import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SalesPage } from './pages/SalesPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { initPixel, trackPageView } from './lib/fbpixel';
function PixelTracker() {
  const location = useLocation();
  useEffect(() => {
    initPixel();
  }, []);
  useEffect(() => {
    // Fire PageView on every route change (after initial init)
    trackPageView();
  }, [location.pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <PixelTracker data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<SalesPage videoId="1190178521" data-id="element-4" />} data-id="element-3" />
        <Route path="/vsl2" element={<SalesPage videoId="1190178711" data-id="element-6" />} data-id="element-5" />
        <Route path="/gracias" element={<ThankYouPage data-id="element-8" />} data-id="element-7" />
      </Routes>
    </BrowserRouter>;
}